import tunnel from 'tunnel-rat';

export const transcriptFindTunnel = tunnel();
